
/**
 * @export
 * @enum {string}
 */
export enum CrmEntityType {
    ACCOUNT = 'ACCOUNT',
    CONTACT = 'CONTACT',
    LEAD = 'LEAD'
}